module.exports = __webpack_public_path__ + "static/media/SupermarketDesigner.37e1c738.jpg";